/* angular:styles/component:css;8625bbf59ebe4ff71ae4198a3928eb209d7c7bcc8599039b44bd21f2468f1163;/app/frontend_mobile/src/app/components/impersonate-user-modal/impersonate-user-modal.component.ts */
.impersonate-content {
  --padding-start: 12px;
  --padding-end: 12px;
  --padding-top: 10px;
  --padding-bottom: 10px;
  --background: var(--ion-color-light, #f4f5f8);
}
.impersonate-list {
  background: transparent;
  padding: 0;
}
.impersonate-item {
  --background: var(--ion-background-color, #fff);
  --border-radius: 12px;
  --padding-start: 16px;
  --inner-padding-end: 12px;
  --min-height: 60px;
  margin-bottom: 10px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}
.impersonate-item h3 {
  font-weight: 600;
  margin-bottom: 2px;
}
.impersonate-item p {
  color: var(--ion-color-medium, #92949c);
  font-size: 13px;
}
.impersonate-empty {
  color: var(--ion-color-medium, #92949c);
  margin-top: 24px;
}
/*# sourceMappingURL=impersonate-user-modal.component.css.map */
